/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState } from 'react' // eslint-disable-line

import { Drawer, Divider, Popconfirm, Button, Tabs, message, notification } from 'antd'
import Markdown from 'react-markdown'

import { agentAction } from '../../action/agent'
import { instanceAction } from '../../action/instance'
import { ViewerStyles } from './styles'
import { MachineInstance, Machine } from '../../business/define'
import BusinessStatus from '../../business/status'
import StatusTag from '../../components/StatusTag'

import { listLoader } from '../../store/list/ListLoader'

import * as ContextUtils from '../../utils/context'
import * as GeneralUtils from '../../utils/general'

import SimpleDrawer from '../SimpleDrawer'

const ACTION_CONDITION: any = {
  query: [],
  create: [{ status: 1, vm_status: 0 }],
  register: [{ status: 1, vm_status: 5 }],
  call_create: [{ status: 1, vm_status: 5 }, { status: 10 }],
  terminate: [{ status: 10 }],
  remove: [{ status: 101, vm_status: 30 }],
  call_remove: [{ status: 101, vm_status: 40 }],
}
const isActionDisabled = (record: any, type: string) => {
  return GeneralUtils.isActionDisabled(record, type, ACTION_CONDITION)
}

export default (props: any) => {
  const [instance, onInstanceChange] = useState<MachineInstance>(null)
  const [machine, onMachineChange] = useState<Machine>(null)
  const [attribute, onMachineAttributeChange] = useState<any>(null)
  const [visible, onVisibleChange] = useState(false)
  const [isHack, onSetIsHack] = useState(true)

  const loadInstanceData = () => {
    instanceAction
      .fetchInstanceInfo(props['instance_id'])
      .then((responseData: any) => {
        onInstanceChange(responseData.instance)
        onMachineChange(responseData.machine)
        onMachineAttributeChange(responseData.attribute)
        onVisibleChange(true)

        if (responseData.instance && [1, 10].includes(Number(responseData.instance.status))) {
          onSetIsHack(false)
        }
      })
      .catch((err: Error) => {
        message.warning(err.message)
      })
  }

  const onClickButton = () => {
    loadInstanceData()
  }

  const onReloadView = (caller: Promise<any>, text: string) => {
    return caller.then(responseData => {
      message.info(text)
      listLoader.reloadListPage()
      loadInstanceData()

      return responseData
    })
      .catch((err) => {
        message.warning(err.message)
        return false
      })
  }

  const onCreateMachineInstance = (instanceId: string) => {
    onReloadView(agentAction.createInstance(instanceId), '创建实例成功')
  }

  const onRegisterMachineInstance = (instanceId: string) => {
    onReloadView(agentAction.registerAgentInstance(instanceId), '注册实例信息成功')
  }

  const onCallCreateMachineInstance = (instanceId: string) => {
    onReloadView(agentAction.callCreateInstance(instanceId), '创建实例成功')
  }

  const onTerminateMachineInstance = (instanceId: string) => {
    onReloadView(agentAction.terminateAgentInstance(instanceId), '终止实例成功')
  }

  const onRemoveMachineInstance = (instanceId: string) => {
    onReloadView(agentAction.removeAgentInstance(instanceId), '删除实例成功')
  }

  const onSearchInstance = (instanceId: string) => {
    agentAction.fetchAgentInstanceInfo(instanceId)
      .then(responseData => {
        notification.open({
          message: '机器实例状态查询',
          description: <pre>{JSON.stringify(responseData.vm || {}, null, '  ')}</pre>,
          onClick: () => {
            console.log('Notification Clicked!');
          },
        })
      })
      .catch((err) => {
        message.warning(err.message)
      })
  }

  return (
    <div css={ViewerStyles["data-drawer"]}>
      <Button type="link" onClick={onClickButton}>
        {props['instance_id']}
      </Button>
      {
        instance && <Drawer
          width="480"
          title={`实例[${instance.id}]`}
          placement="right"
          onClose={() => {
            onVisibleChange(false)
          }}
          visible={visible}
        >
          <div css={ViewerStyles["drawer-body"]}>
            <p css={ViewerStyles.title}>
              <SimpleDrawer title="实例操作" disabled={isHack} content={`实例管理: ${props['instance_id']}`}>
                <Button block
                  disabled={isActionDisabled(instance, 'call_create')}
                  onClick={() => { onCallCreateMachineInstance(props['instance_id']) }}
                >创建容器</Button>
                <Divider />
                <Button block ghost disabled type="danger">停止容器</Button>
                <Divider />
                <Button block ghost disabled type="danger">删除容器</Button>
              </SimpleDrawer>
            </p>
            <p>
              <span>实例状态：</span>
              <StatusTag item={instance} status={instance.status} config={BusinessStatus.instance} />
              <StatusTag item={instance} status={instance.vm_status} config={BusinessStatus.instance_vm} />
            </p>
            <Tabs defaultActiveKey="instance">
              <Tabs.TabPane tab="实例信息" key="instance">
                <Markdown source={ContextUtils.buildJsonMarked(instance)} />
              </Tabs.TabPane>
              {
                machine && <Tabs.TabPane tab="机器信息" key="machine">
                  <Markdown source={ContextUtils.buildJsonMarked(machine)} />
                </Tabs.TabPane>
              }
              {
                attribute && <Tabs.TabPane tab="机器属性" key="attribute">
                  <Markdown source={ContextUtils.buildJsonMarked(attribute)} />
                </Tabs.TabPane>
              }
            </Tabs>
          </div>
          <div css={ViewerStyles["drawer-footer"]}>
            <Button
              disabled={isActionDisabled(instance, 'query')}
              onClick={() => { onSearchInstance(props['instance_id']) }}
            >查询</Button>
            <Button
              disabled={isActionDisabled(instance, 'create')}
              onClick={() => { onCreateMachineInstance(props['instance_id']) }}
            >创建</Button>
            <Button
              disabled={isActionDisabled(instance, 'register')}
              onClick={() => { onRegisterMachineInstance(props['instance_id']) }}
            >注册</Button>
            {/* <Button type="primary">启动</Button> */}
            <Popconfirm
              title="终止机器不可撤销，确认操作吗?"
              onConfirm={() => { onTerminateMachineInstance(props['instance_id']) }}
              okText="是"
              cancelText="否"
              disabled={isActionDisabled(instance, 'terminate')}
            >
              <Button
                disabled={isActionDisabled(instance, 'terminate')}
                type="danger"
              >终止</Button>
            </Popconfirm>

            <Button
              disabled={isActionDisabled(instance, 'remove')}
              onClick={() => { onRemoveMachineInstance(props['instance_id']) }}
              type="danger" ghost
            >删除</Button>
          </div>
        </Drawer>
      }
    </div>
  )
}